// src/pages/Dashboard.jsx
import React from 'react';
import Overview from './Overview';

const Dashboard = () => {
  return <Overview />;
};

export default Dashboard;
